import { render, staticRenderFns } from "./RelatedEvents.vue?vue&type=template&id=4e1f649c&scoped=true&"
import script from "./RelatedEvents.vue?vue&type=script&lang=js&"
export * from "./RelatedEvents.vue?vue&type=script&lang=js&"
import style0 from "./RelatedEvents.vue?vue&type=style&index=0&id=4e1f649c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1f649c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDivider,VIcon,VRow})
